import React from "react";
import BackgroundCover from "../../components/backgroundCover/BackgroundCover";
import TitleWithDescription from "../../components/TitleWithDescription/TitleWithDescription";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import Title from "../../components/Title/Title";
import { useLanguage } from "../../context/LanguageContext";
import { getDiamondGlassTranslations } from "../../translations/diamondGlassTemplate";
import { isMobileOrTablet } from "../../utils/appUtils";
import { isMobile } from "../../utils/appUtils";
import { useEditMode } from "../../context/EditModeContext";
import EditableText from "../../components/EditableText/EditableText";
import { usePageContent } from "../../hooks/usePageContent";
import { DiamondGlassTranslations } from "../../translations/diamondGlassTemplate";

function DiamondGlass() {
    const { language } = useLanguage();
    const { isEditMode } = useEditMode();
    const { content, loading } = usePageContent<DiamondGlassTranslations>('diamond-glass');

    // Use translations as fallback content
    const t = content || getDiamondGlassTranslations(language);

    // Show loading state if needed
    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin h-12 w-12 border-2 border-gray-400 rounded-full border-t-transparent"></div>
            </div>
        );
    }

    return (
        <div className="">
            <BackgroundCover
                backgroundHeight={isMobileOrTablet() ? (isMobile() ? 400 : 600) : undefined}
                imagePosition={isMobileOrTablet() ? (isMobile() ? "center" : "initial") : "initial"} backgroundImage="/images/diamond_glass/diamond_glass_bg.png"
            >
                <div className="absolute top-1/2 left-[10%] -translate-y-1/2 z-10 hidden md:block">
                    <Title
                        firstLine={isEditMode ? (
                            <EditableText
                                contentKey="diamond-glass.title.firstLine"
                                defaultValue={t.title.firstLine}
                            />
                        ) : t.title.firstLine}
                        secondLine={isEditMode ? (
                            <EditableText
                                contentKey="diamond-glass.title.secondLine"
                                defaultValue={t.title.secondLine}
                            />
                        ) : t.title.secondLine}
                        className="hidden md:block"
                        animate={true}
                    />
                </div>
            </BackgroundCover>

            <div className="mx-auto px-4 py-6 md:py-24">
                <div className="block md:hidden mb-8">
                    <Title
                        firstLine={isEditMode ? (
                            <EditableText
                                contentKey="diamond-glass.title.firstLine"
                                defaultValue={t.title.firstLine}
                            />
                        ) : t.title.firstLine}
                        secondLine={isEditMode ? (
                            <EditableText
                                contentKey="diamond-glass.title.secondLine"
                                defaultValue={t.title.secondLine}
                            />
                        ) : t.title.secondLine}
                        className=""
                        animate={true}
                    />
                </div>
                <div className="flex flex-col items-center">
                    <div className="max-w-4xl text-sm text-gray-600 leading-relaxed">
                        {isEditMode ? (
                            <EditableText
                                contentKey="diamond-glass.introduction"
                                defaultValue={t.introduction}
                                multiline={true}
                            />
                        ) : t.introduction}
                    </div>
                </div>
            </div>

            <div className="relative w-full overflow-hidden">
                <div className="w-full bg-gradient-to-b from-[#E1D8D3] via-[#FFFFFF] to-[#E1D8D3] pb-12 md:py-12">
                    <div className="mx-auto px-4 md:px-12 lg:pt-8 max-w-7xl">
                        {t.sections.map((section, index) => (
                            <TimelineSection
                                key={index}
                                title={{
                                    firstLine: " ",
                                    secondLine: " ",
                                }}
                                description={isEditMode ? (
                                    <EditableText
                                        contentKey={`diamond-glass.sections.${index}.description`}
                                        defaultValue={section.description}
                                        multiline={true}
                                    />
                                ) : section.description}
                                media={{
                                    type: 'image',
                                    src: `/images/diamond_glass/Synthetic_Diamond_${index + 1}.png`,
                                    alt: `Diamond Glass Process Step ${index + 1}`
                                }}
                                mediaPosition={index % 2 === 0 ? "right" : "left"}
                                showLine={index !== t.sections.length - 1}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DiamondGlass; 